import { render, staticRenderFns } from "./shop-list.vue?vue&type=template&id=b2e6a126&"
import script from "./shop-list.vue?vue&type=script&lang=js&"
export * from "./shop-list.vue?vue&type=script&lang=js&"
import style0 from "./shop-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports